import React from 'react';

export function SourceTermsAndServices({ connectorType }) {
  if (connectorType === 'YOUTUBE_ANALYTICS') {
    return (
      <p className='mt-3 text-center text-secondary'>
        You are sharing sensitive{' '}
        <a
          href='https://myaccount.google.com/permissions'
          className='text-link thumbnail-right '
          target='_blank'
          rel='noreferrer'
        >
          account data
        </a>{' '}
        with Hevo. Read about{' '}
        <a
          href='https://policies.google.com/privacy'
          className='text-link thumbnail-right'
          target='_blank'
          rel='noreferrer'
        >
          Google's Privacy Policy
        </a>{' '}
        . You can delete any unused accounts, if needed. Hevo uses YouTube’s API Services to fetch
        your data in compliance with{' '}
        <a
          href='https://www.youtube.com/t/terms'
          className='text-link thumbnail-right'
          target='_blank'
          rel='noreferrer'
        >
          YouTube's Terms of Service
        </a>
        .
      </p>
    );
  }
  return null;
}
